import React from 'react'
import classNames from 'classnames'
import { node, string, object, array, oneOfType } from 'prop-types'

const ColGroup = ({ children, className }) => (
  <colgroup className={classNames('sw-table-colgroup', className)}>{children}</colgroup>
)

ColGroup.displayName = 'ColGroup'

ColGroup.propTypes = {
  /** Component's children */
  children: node,
  /** Custom className */
  className: oneOfType([string, object, array])
}

export default ColGroup
